/**
 * Auth0 plugin instance holder. Set in main.ts after createAuth0() so the router
 * and API layer can access the client without being inside a component (useAuth0()).
 */
import type { Auth0VueClient } from '@auth0/auth0-vue'

let auth0Instance: Auth0VueClient | null = null

export function setAuth0Client(client: Auth0VueClient | null): void {
  auth0Instance = client
}

export function getAuth0Client(): Auth0VueClient | null {
  return auth0Instance
}

/** Returns the current access token from Auth0, or null if not authenticated. */
export async function getAccessToken(): Promise<string | null> {
  const client = getAuth0Client()
  if (!client?.isAuthenticated.value) return null
  try {
    return await client.getAccessTokenSilently()
  } catch {
    return null
  }
}

/** Wait until Auth0 has finished initial load (e.g. processing callback). Used by router guard. */
export function waitForAuthReady(timeoutMs = 5000): Promise<void> {
  const client = getAuth0Client()
  if (!client) return Promise.resolve()
  return new Promise((resolve) => {
    const start = Date.now()
    const check = (): void => {
      if (!client.isLoading.value || Date.now() - start > timeoutMs) {
        resolve()
        return
      }
      setTimeout(check, 50)
    }
    check()
  })
}
